/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import androidFilled from '@iconify/icons-ant-design/android-filled';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
import NaturePeopleIcon from '@material-ui/icons/NaturePeople';
import CountUp from 'react-countup';
import TokenDecoder from '../../../helpers/TokenDecoder';


// utils
import { fShortenNumber } from '../../../utils/formatNumber';
import dashboardService from './DashboardService'


// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: theme.palette.primary.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

export default function AppWeeklySales() {

  const OpID = parseInt(TokenDecoder.getGroupFactoryToken().factory);

  const [farmer, setFarmer] = useState(0);

  async function GetfarmerCount() {
    const response = await dashboardService.getFarmerCount(OpID);
    if (response.length > 0) {
      setFarmer(response[0].farmerCount);
    }
  }
  useEffect(() => {
    GetfarmerCount();
  }, [])

  return (
    <RootStyle>
      <IconWrapperStyle>
        <NaturePeopleIcon fontSize='large' width={50} height={60} />
      </IconWrapperStyle>
      <Typography variant="h3"><CountUp end={farmer} /></Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Active Farmers
      </Typography>
    </RootStyle>
  );
}
